import jack from 'jack-logs';
import { updatePinLength } from '../settings/organisation/actions';
import { doRequest } from '../requests/actions';
import * as lib from './lib';

export const actions = {
  SET: 'EMPLOYEES_SET',
  ADD: 'EMPLOYEES_ADD',
  REMOVE: 'EMPLOYEES_REMOVE',
  CLOCK_IN: 'EMPLOYEES_CLOCK_IN',
  CLOCK_OUT: 'EMPLOYEES_CLOCK_OUT',
  UPDATE_CLOCKED_IN: 'EMPLOYEES_UPDATE_CLOCKED_IN',
  CLEAR: 'EMPLOYEES_CLEAR',
};

export function set(employees) {
  return {
    type: actions.SET,
    value: employees,
  };
}

export function add(employee) {
  return {
    type: actions.ADD,
    value: employee,
  };
}

export function remove(id) {
  return {
    type: actions.REMOVE,
    value: id,
  };
}

export function clockIn(id) {
  return {
    type: actions.CLOCK_IN,
    value: id,
  };
}

export function clockOut(id) {
  return {
    type: actions.CLOCK_OUT,
    value: id,
  };
}

export function clear() {
  return {
    type: actions.CLEAR,
  };
}

export function updateClockedIn(clockedIn) {
  return {
    type: actions.UPDATE_CLOCKED_IN,
    value: clockedIn,
  };
}

export function performClock(clockObject, image) {
  return async (dispatch, getState) => {
    const delta = getState().getIn(['device', 'delta']);
    const clockin = lib.generateClockObject(clockObject, image, delta);
    if (clockin.photo && clockin.photo.length < 400) {
      // this is very, *very* likely an empty photo so we should just reject the clockin
      // see https://trello.com/c/DZf2pQz4/5076-retinology-institute-id-86307-staff-member-timeclock-photos-sporadically-not-showing-up
      return;
    }
    dispatch(doRequest({ endpoint: '/clockins', method: 'POST', data: clockin }));
  };
}

export function doClock(id, time, image, type) {
  return async (dispatch, getState) => {
    const deviceId = getState().getIn(['device', 'deviceId']);
    await dispatch(performClock({
      type,
      time,
      device_id: deviceId,
      user_id: id,
    }, image));

    if (type === 'clockin') {
      return dispatch(clockIn(id));
    }

    return dispatch(clockOut(id));
  };
}

export function get() {
  return async (dispatch) => {
    // lazy load some employees
    const employees = await dispatch(doRequest({ endpoint: '/users' }));
    if (employees === null) {
      throw new Error('Could not retrieve employees');
    }
    if (employees) {
      dispatch(set(employees));
      return dispatch(updatePinLength(employees));
    }
    return null;
  };
}

export function setTeam(employee) {
  return async (dispatch) => {
    const { id, team } = employee;
    if (!id || id === '') {
      throw new Error('id must be specified.');
    }

    if (!team || team === '') {
      throw new Error('team must be specified.');
    }

    return dispatch(doRequest({
      endpoint: `/users/${id}`,
      method: 'PUT',
      data: {
        department_ids: [team.id],
      },
    }));
  };
}

export function create(employee) {
  return async (dispatch) => {
    const { name, team } = employee;
    if (!name || name === '') {
      throw new Error('name must be specified.');
    }

    if (!team || team === '') {
      throw new Error('team must be specified.');
    }

    return dispatch(doRequest({
      endpoint: '/users',
      method: 'POST',
      data: {
        name,
        department_ids: [team.id],
      },
    }));
  };
}

export function createMultiple(employees) {
  return async dispatch =>
    Promise.all(employees.map(async (employee) => {
      const emp = await dispatch(create(employee));
      dispatch(add(emp));
      return emp;
    }));
}

/**
 * Refreshes the employee list, and the the clockedIn line
 * @returns {function(*)}
 */
export function refresh() {
  return async (dispatch) => {
    // get retrieves employees, sets the as the list, and the updates the pinLength details
    try {
      await dispatch(get());
      const clockedIn = await dispatch(doRequest({ endpoint: '/shifts/active' }));
      if (clockedIn) {
        dispatch(updateClockedIn(clockedIn.map(clock => clock.user_id)));
      }
    } catch (e) {
      jack.error(e);
    }
  };
}



// WEBPACK FOOTER //
// ./src/store/employees/actions.js